import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getFontWeight, getVisuallyHiddenStyles } from './typography.utils';
import { useLinkStyles } from './link.styles';
import { useTheme } from '../theme';
const StyledTypography = styled(Typography)({});
const LinkElement = ({ children, fontWeight, tag = 'span', themeName, className, onClick, startIcon, color, ...props })=>{
    // For link elements, the semantics change depending on the presence of a click handler
    // if there is a click handler, return a button element
    // if there is no click handler, return a span element
    const theme = useTheme(themeName);
    const styles = useLinkStyles({
        themeName,
        color
    });
    const element = /*#__PURE__*/ _jsxs(StyledTypography, {
        ...props,
        component: tag,
        className: className,
        sx: {
            ...styles.link,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        children: [
            startIcon,
            children
        ]
    });
    if (onClick) {
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            css: styles.button,
            className: className,
            onClick: onClick,
            children: element
        });
    }
    return element;
};
export const Heading = ({ children, fontWeight, color, variant, tag, themeName, className, isVisuallyHidden, ...props })=>{
    const theme = useTheme(themeName);
    const variantToTag = {
        displayL: 'h1',
        displayM: 'h2',
        displayS: 'h3',
        titleH1: 'h1',
        titleH2: 'h2',
        titleH3: 'h3',
        titleH4: 'h4'
    };
    return /*#__PURE__*/ _jsx(StyledTypography, {
        ...props,
        variant: variant,
        component: tag || variantToTag[variant],
        className: className,
        sx: {
            ...isVisuallyHidden && getVisuallyHiddenStyles(),
            color,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        children: children
    });
};
export const BodyL = ({ children, fontWeight, color, tag = 'p', themeName, className, isVisuallyHidden, ...props })=>{
    const theme = useTheme(themeName);
    return /*#__PURE__*/ _jsx(StyledTypography, {
        ...props,
        variant: "bodyL",
        component: tag,
        className: className,
        sx: {
            ...isVisuallyHidden && getVisuallyHiddenStyles(),
            color,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        children: children
    });
};
export const BodyM = ({ children, fontWeight, color, tag = 'p', themeName, className, isVisuallyHidden, ...props })=>{
    const theme = useTheme(themeName);
    return /*#__PURE__*/ _jsx(StyledTypography, {
        variant: "bodyM",
        component: tag,
        className: className,
        sx: {
            ...isVisuallyHidden && getVisuallyHiddenStyles(),
            color,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        ...props,
        children: children
    });
};
export const LinkM = (props)=>{
    return /*#__PURE__*/ _jsx(LinkElement, {
        ...props,
        variant: "linkM"
    });
};
export const BodyS = ({ children, fontWeight, color, tag = 'p', themeName, className, isVisuallyHidden, ...props })=>{
    const theme = useTheme(themeName);
    return /*#__PURE__*/ _jsx(StyledTypography, {
        ...props,
        variant: "bodyS",
        component: tag,
        className: className,
        sx: {
            ...isVisuallyHidden && getVisuallyHiddenStyles(),
            color,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        children: children
    });
};
export const LinkS = (props)=>{
    return /*#__PURE__*/ _jsx(LinkElement, {
        ...props,
        variant: "linkS"
    });
};
export const Caption = ({ children, fontWeight, color, tag = 'span', themeName, className, isVisuallyHidden, ...props })=>{
    const theme = useTheme(themeName);
    return /*#__PURE__*/ _jsx(StyledTypography, {
        ...props,
        variant: "caption",
        component: tag,
        className: className,
        sx: {
            ...isVisuallyHidden && getVisuallyHiddenStyles(),
            color,
            fontWeight: getFontWeight({
                theme,
                fontWeight
            }),
            fontFamily: theme.typography.fontFamily
        },
        children: children
    });
};
export const CaptionLink = (props)=>{
    return /*#__PURE__*/ _jsx(LinkElement, {
        ...props,
        variant: "captionLink"
    });
};

//# sourceMappingURL=typographyElements.js.map